export default __webpack_public_path__ + "f0a1f6e79b3f60abac0ed5f36d49c0d2.svg";